import Avatar from "@/components/common/Avatar";
import PropTypes from "prop-types";

const CandidateHeader = ({ candidate, runningMate }) => {
  return (
    <div className="h-full gap-2 rounded-lg 2xl:flex">
      <img
        src={candidate.coverImage}
        alt={candidate.name}
        className="w-full 2xl:w-[194px] h-full object-cover rounded-xl 2xl:mb-0 mb-4"
      />
      <div className="flex flex-col justify-between w-full">
        <div>
          <h1 className="mb-2 text-3xl font-bold">{candidate.name}</h1>
          <p className="mb-1 text-bold-x">{candidate.position}</p>
          <p className="mb-4 text-regular text-lighterGrey">
            {candidate.location}
          </p>
        </div>

        {runningMate && (
          <div className="flex items-center gap-3 2xl:mb-3">
            <Avatar src={runningMate.avatar} size={40} />
            <div>
              <p className="heading-medium">{runningMate.name}</p>
              <p className="text-small text-lighterGrey">Running Mate</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CandidateHeader.propTypes = {
  candidate: PropTypes.shape({
    name: PropTypes.string,
    position: PropTypes.string,
    location: PropTypes.string,
    coverImage: PropTypes.string,
  }),
  runningMate: PropTypes.shape({
    name: PropTypes.string,
    avatar: PropTypes.string,
  }),
};

export default CandidateHeader;
